import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

export default function Notifications({ user }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user?.uid) return;
    const qy = query(
      collection(db, "notifications"),
      where("userUid", "==", user.uid),
      orderBy("createdAt", "desc")
    );
    return onSnapshot(qy, (s) => {
      const arr = [];
      s.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setItems(arr);
    });
  }, [user?.uid]);

  return (
    <div className="max-w-3xl mx-auto mt-8 md:mt-16">
      <h1 className="text-2xl font-bold mb-4">Notifications</h1>
      <div className="space-y-3">
        {items.map((n) => (
          <div key={n.id} className="p-4 bg-slate-800 rounded-xl">
            <div className="font-semibold">{n.title || "Update"}</div>
            <div className="text-sm text-slate-300">{n.body}</div>
            <div className="text-xs text-slate-500 mt-1">
              {new Date(
                n.createdAt?.toDate?.() || n.createdAt
              ).toLocaleString()}
            </div>
          </div>
        ))}
        {!items.length && (
          <div className="text-slate-400">No notifications yet.</div>
        )}
      </div>
    </div>
  );
}
